import Page from './select-store'
export default Page